export function base64ToHex(base64: string) {
  // Decode the Base64 string to a binary string
  const binaryString = atob(base64)
  let hexString = ''

  // Convert each character in the binary string to hexadecimal
  for (let i = 0; i < binaryString.length; i++) {
    const hexChar = binaryString.charCodeAt(i).toString(16)
    // Ensure two-digit representation
    hexString += hexChar.length === 2 ? hexChar : '0' + hexChar
  }

  return hexString.toUpperCase() // Convert to uppercase for consistency
}
